import React from 'react';
import type { FC }  from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Switch } from 'react-router-dom';
import { CypressHistorySupport } from 'cypress-react-router';
import 'react-perfect-scrollbar/dist/css/styles.css';
import configureStore from './redux/store';
import AppWrapper from './@jumbo/components/AppWrapper';
import AppContextProvider from './@jumbo/components/contextProvider/AppContextProvider';
import Routes from '@/routes/index.js';
import ErrorHandler from '@/components/ErrorHandler';

export const store = configureStore();

const App : FC = () => {
	return (
		<React.StrictMode>
			<Provider store={store}>
				<BrowserRouter>
					<CypressHistorySupport />

					<AppContextProvider>
						<AppWrapper>
							<ErrorHandler>
								<Switch>
									<Routes />
								</Switch>
							</ErrorHandler>
						</AppWrapper>
					</AppContextProvider>
				</BrowserRouter>
			</Provider>
		</React.StrictMode>
	);
};

export default App;
